export enum OPERATING_SYSTEM {
    android = 'android',
    iOS = 'iOS',
    unknown = 'unknown',
}
